var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
// Components
import { Modal } from '@frontend_zz/modal/Modal.js';
// Styles
import styles from './Drawer.css.js';
// Typings
export const drawerAnchorOptions = ['block-start', 'block-end', 'inline-start', 'inline-end'];
/**
 * @element zz-drawer
 * @extends Modal
 */
export class Drawer extends Modal {
    constructor() {
        super(...arguments);
        this.anchor = 'inline-start';
    }
    static get styles() {
        return [Modal.styles, styles];
    }
    connectedCallback() {
        super.connectedCallback();
        this.surfaceVariant = this.modal
            ? 'elevated-not-clickable-centered-with-backdrop'
            : 'elevated-not-clickable-centered';
    }
}
__decorate([
    property({ type: String, reflect: true })
], Drawer.prototype, "anchor", void 0);
